import { TFunction } from 'i18next';
import { Dispatch } from 'react';
import {
    FetchedTelemetryEvent,
    Sorting,
} from 'ducks/vehicleTelemetryEvents/types';
import { setSort } from 'ducks/vehicleTelemetryEvents';
import { DateTimeFormatter } from 'ducks/common/types';

export const getColumns = (t: TFunction, dispatch: Dispatch<any>) => {
    return [
        {
            title: t('bikeAndVaeTelemetryEvents.timeStamp'),
            field: 'timestamp',
            render: (rowProps: FetchedTelemetryEvent) =>
                rowProps.timestamp
                    ? DateTimeFormatter.format(new Date(rowProps.timestamp))
                    : '-',
            onClick: () =>
                dispatch(
                    setSort({
                        value: Sorting.timestamp,
                    }),
                ),
        },
        {
            title: t('bikeAndVaeTelemetryEvents.type'),
            field: 'type',
            render: (rowProps: FetchedTelemetryEvent) =>
                t(`bikeAndVaeTelemetryEvents.types.${rowProps.msgCode}`),
            sorting: false,
        },
    ];
};
